import script from "./workorderDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./workorderDetails.vue?vue&type=script&setup=true&lang=js"

import "./workorderDetails.vue?vue&type=style&index=0&id=a87c9e2a&scoped=true&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a87c9e2a"]])

export default __exports__